/* ── Proceso 4 pasos ──────────────────────────────────────────────────── */
const PASOS = [
  { n: 'Paso 1', t: 'Cotiza.', d: 'Dinos qué coche quieres y arma tu plan en minutos, aquí o por WhatsApp.' },
  { n: 'Paso 2', t: 'Llena tu solicitud.', d: 'Un proceso digital, claro y sin papeleo. Te acompañamos en cada campo.' },
  { n: 'Paso 3', t: 'Firma y paga.', d: 'Firma tu contrato y realiza tu pago inicial de forma segura, en línea.' },
  { n: 'Paso 4', t: 'A estrenar.', d: 'Recibe tu auto y disfruta. La llave a tu movilidad, lista.' },
];

const Proceso = () => (
  <section className="sec proceso" id="proceso">
    <div className="wrap reveal">
      <div className="head">
        <div className="sec-eyebrow">Proceso Peicar</div>
        <h2 className="sec-title">Tu coche en <b>4 pasos.</b></h2>
        <p className="sec-lead">Fácil, rápido y sin papeleo. Comienza tu experiencia de forma digital.</p>
      </div>
      <div className="steps">{PASOS.map(s => (<div className="pstep" key={s.n}><div className="num">{s.n}</div><div className="ttl">{s.t}</div><div className="line"></div><div className="desc">{s.d}</div></div>))}</div>
    </div>
  </section>
);

export default Proceso;
